import {
  BulbOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import {
  Alert,
  Badge,
  Button,
  Col,
  Form,
  Popover,
  Row,
  Typography,
  theme,
} from 'antd';
import { Header } from 'antd/es/layout/layout';
import { BroadcastChannel } from 'broadcast-channel';
import { useState } from 'react';
import { api } from '../../app/baseQuery';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { TUser, logout, selectUser } from '../../auth/states/userSlice';
import { globalTheme, setTheme } from '../../common/slices/themeSlice';
import Notification from '../../components/notificatioin/Notification';

import { faMoon } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Marquee from 'react-fast-marquee';
import { Link, useNavigate } from 'react-router-dom';
import { storageBaseUrl } from '../../common/utils/common.utils';
import { useGetSMSBalanceQuery } from '../../modules/SMS System/Api/Endpoints/SMSEndpoints';
import { userContent } from '../components/layout.utils';
import '../style/layoutStyle.css';
import GlobalSearch from './GlobalSearch';

type Props = {
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  collapsed: boolean;
};

const HeaderContainer = ({ collapsed, setCollapsed }: Props) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const { data: sms } = useGetSMSBalanceQuery();
  const logoutChannel = new BroadcastChannel('logout');
  // const primaryColor = useAppSelector((state) => state.color.primaryColor);

  const handleLogout = () => {
    logoutChannel.postMessage('Logout');
    dispatch(api.util.resetApiState());
    dispatch(logout());
    navigate('./login');
  };

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const dispatch = useAppDispatch();

  const user = useAppSelector(selectUser);
  const agencyInfo = user?.organization_info;
  const themeGlobal = useAppSelector(globalTheme);
  const handleTheme = () => {
    dispatch(
      setTheme(
        themeGlobal.theme === theme.defaultAlgorithm
          ? theme.darkAlgorithm
          : theme.defaultAlgorithm
      )
    );
  };

  const handleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Header
      className='header'
      style={{ padding: 0, background: colorBgContainer }}
    >
      <div className='header-container'>
        <div className='left-items'>
          <Button
            type='text'
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => handleCollapsed()}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />


          <GlobalSearch />
        </div>
        {Number(user?.remaining_days) <= 7 && (
          <Row justify={'center'}>
            <Col md={15}>
              <Alert
                banner
                message={
                  <Marquee pauseOnHover gradient={false}>
                    <Typography.Title level={5}>
                      Your subscription will be expired within
                      {Number(user?.remaining_days)} days
                    </Typography.Title>
                  </Marquee>
                }
              />
            </Col>
          </Row>
        )}
        <div className='right-side-items'>
          {/* ------------PDF SCANNER-------------- */}
          {/* <Scanner /> */}
          <Badge
            size='small'
            offset={[-20, 0]}
            count={
              isHovered
                ? `SMS Balance : ${Math.ceil(
                    (Number(
                      sms?.Data !== null &&
                        sms?.Data[0].Credits?.replace('BDT', '')
                    ) || 0) / 2
                  )}`
                : undefined
            }
            style={{
              background: '#ffffff',
              color: '#18b4e9',
              fontSize: 12,
              fontWeight: 700,
              marginRight: 30,
            }}
          >
            <Link to={'/sms'}>
              <svg
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                  cursor: 'pointer',
                  marginRight: 12,
                }}
                xmlns='http://www.w3.org/2000/svg'
                height={40}
                width={40}
                viewBox='0 0 512 512'
              >
                <path
                  fill='#18b4e9'
                  d='M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM202.9 176.8c6.5-2.2 13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2zm173.1 38c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.2-.4-23.7-4.4-32.6-7.4l0 0 0 0c-1.4-.5-2.7-.9-4-1.4c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7 .6 3.3 1.1 4.9 1.6l0 0 0 0c9.1 3.1 15.6 5.3 22.6 5.5c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6c-9-5.4-17.7-14.7-17.7-29.4c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c10 .2 19.7 2.3 27.9 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9zm-272 0c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.3-.4-24.2-4.5-33.2-7.6l0 0 0 0c-1.3-.4-2.5-.8-3.6-1.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4 .5 2.8 .9 4.1 1.4l0 0 0 0c9.5 3.2 16.5 5.6 23.7 5.8c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4 0 0c-7.2-2.2-16.7-5-24.3-9.6C80.8 239 72.1 229.7 72 215c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c9.5 .1 22.2 2.1 31.1 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9z'
                />
              </svg>
            </Link>
          </Badge>

          <Notification />

          <Button
            className='item'
            onClick={handleTheme}
            icon={
              themeGlobal.theme === theme.defaultAlgorithm ? (
                <BulbOutlined />
              ) : (
                <FontAwesomeIcon icon={faMoon} />
              )
            }
            type='primary'
          />

          {/* <AppStyle /> */}

          <Popover
            fresh
            forceRender={true}
            style={{ overflow: 'hidden' }}
            content={userContent(
              isModalOpen,
              setIsModalOpen,
              handleLogout,
              user as TUser,
              handleCancel
            )}
            trigger='click'
          >
            <img
              className='org_logo item'
              src={storageBaseUrl + agencyInfo?.org_logo}
              alt={agencyInfo?.org_name || 'M360-ICT'}
            />
          </Popover>
        </div>
      </div>
    </Header>
  );
};

export default HeaderContainer;
